import firebase from './firebase';

export const callCloudFunction = async (name: string) => {
	return (await firebase.functions().httpsCallable(name));
}